const environments = {
    PROD: {api_path: "api2.", script_path: ""},
    DEV: {api_path: "api2.dev.", script_path: "dev."},
    BETA: {api_path: "api2.beta.", script_path: "beta."},
    KAPPA: {api_path: "api2.kappa.", script_path: "kappa."},
    STAGE: {api_path: "api2.stage.", script_path: "stage."}
};

export const getEnvironment = function (callingSource) {
    let href = window.location.href;
    if (
        href.indexOf("localhost") > -1 ||
        href.indexOf("dev.shutterfly.com") > -1 ||
        href.indexOf("share.shutterfly.com") > -1
    ) {
        return callingSource == "API"
            ? environments.DEV.api_path
            : environments.DEV.script_path;
    }

    if (href.indexOf("beta.shutterfly.com") > -1) {
        return callingSource == "API"
            ? environments.BETA.api_path
            : environments.BETA.script_path;
    }

    if (href.indexOf("kappa.shutterfly.com") > -1) {
        return callingSource == "API"
            ? environments.KAPPA.api_path
            : environments.KAPPA.script_path;
    }

    if (href.indexOf("stage.shutterfly.com") > -1) {
        return callingSource == "API"
            ? environments.STAGE.api_path
            : environments.STAGE.script_path;
    }

    return callingSource == "API"
        ? environments.PROD.api_path
        : environments.PROD.script_path;
};
